import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { PriorAuthQueueComponent } from '../../prior-auth-queue/prior-auth-queue.component';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';
@Component({
  selector: 'app-insurer-dashboard',
  templateUrl: './insurer-dashboard.component.html',
  styleUrls: ['./insurer-dashboard.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    PriorAuthQueueComponent,
    DraftEformsQueueComponent,
    SubmittedEformsQueueComponent,
  ],
})
export class InsurerDashboardComponent {
  selectedTabIndex: number;
  @Input() redirectToTabIndex: number;
}
